import { useTransferClinicProductsMutation } from "../../../../../../../api/mutations/useTransferClinicProductsMutation";
import { uiNotification } from "../../../../../../../services/UINotificationService";

export var useSubmit = (fromClinicId) => {
  var { mutateAsync, isLoading } = useTransferClinicProductsMutation({
    onError: () => {
      uiNotification.error("Unable to transfer products. Try again later.");
    },
    onSuccess: () => {
      uiNotification.success("Products transferred successfully.");
    },
  });

  var initiate = async (toClinicId) => {
    if (!toClinicId) {
      uiNotification.error("Please select a clinic to transfer to.");
      return Promise.reject();
    }

    return mutateAsync({
      clinicFromId: fromClinicId,
      clinicToId: toClinicId,
    });
  };

  return {
    initiate,
    isLoading,
  };
};
